export default __webpack_public_path__ + "static/media/bg-paper-blue.c20b8f29.png";